import { useGoogleLogin as useGoogleLogin2 } from "@react-oauth/google";
import useGetEventFromApp from "hooks/useGetEventFromApp";
import { useEffect, useState } from "react";
import useLoginCoach from "./useLoginCoach";
import { COACH_SESSION_KIND } from "api/coachAuth";

/**
 * 코치 Google 로그인. 웹은 팝업 인가 코드를 서버로 보내고 서버가 client_secret 으로 교환한다
 * (예전엔 브라우저가 직접 교환해 시크릿이 번들에 들어 있었다). 앱 경로는 네이티브 idToken 그대로.
 */
export default function useGoogleLoginCoach(onNotCoach?: () => void) {
  const origin = window.location.origin;

  const [idToken, setIdToken] = useState<string>();
  const [code, setCode] = useState<string>();

  const parsedMessageFromApp = useGetEventFromApp();

  useEffect(() => {
    if (parsedMessageFromApp?.event === "google_idToken") {
      const idToken = parsedMessageFromApp.params.value;
      setIdToken(idToken);
    }
  }, [parsedMessageFromApp]);

  const login = useLoginCoach({
    url: `/user/v2/login?kind=${COACH_SESSION_KIND}`,
    requestBody: JSON.stringify(
      code
        ? { code, redirectUri: origin, type: "google" }
        : { idToken, type: "google" }
    ),
    onNotCoach: onNotCoach,
  });

  useEffect(() => {
    if (idToken || code) {
      login();
    }
  }, [idToken, code]);

  const handleGoogleLoginWeb = useGoogleLogin2({
    onSuccess: (codeResponse) => setCode(codeResponse.code),
    flow: "auth-code",
    ux_mode: "popup",
    redirect_uri: origin,
    // 이름·프로필 사진은 쓰지 않는다. 라이브러리 기본값("openid profile email")에서 profile 을 뺀다.
    scope: "openid email",
    overrideScope: true,
  });

  return handleGoogleLoginWeb;
}
